/** Column keys kept in the Evaluations Improve wizard table (Figma 820px layout). */

export const IMPROVE_MODAL_COLUMN_KEYS = Object.freeze([
    'is_in_dataset',
    'request_example',
    'labels',
    'review',
    'moreActions',
]);

export function filterColumnsForImproveModal(columns) {
    const allowed = new Set(IMPROVE_MODAL_COLUMN_KEYS);
    return (columns || []).filter((column) => allowed.has(column.key || column.dataIndex));
}
